"use client"

import { Gift } from "lucide-react"

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { useClientBonusQuery } from "@/hooks/queries/partners"
import { describeClientBonusTerms } from "@/lib/partners/client-bonus-copy"
import { useLocale, useTranslations } from "next-intl"


/** Shown only while the tenant's next payment would earn a bonus from the partner who referred it. */
export function PartnerBonusBanner() {
  const tUi = useTranslations("Billing.BillingPartnerBonusBanner")

  const tBonus = useTranslations("PartnerBonus")
  const locale = useLocale()
  const { data: bonus } = useClientBonusQuery()
  if (!bonus) return null

  return (
    <Alert variant="highlight">
      <Gift className="h-4 w-4" aria-hidden />
      <AlertTitle><span key={tUi("partnerBonus")}>{tUi("partnerBonus")}</span></AlertTitle>
      <AlertDescription>{describeClientBonusTerms(bonus, tBonus, locale)}</AlertDescription>
    </Alert>
  )
}
